module.exports = __webpack_public_path__ + "static/media/5D.434286e8.svg";